import { motion } from "framer-motion";
import { useState } from "react";

import { Button } from "@allaria-tech/matter/Button";
import { Dropdown } from "@allaria-tech/matter/Dropdown";
import { Icon } from "@allaria-tech/matter/Icon";
import { IconButton } from "@allaria-tech/matter/IconButton";

import { getMailLink, getWhatsappLink } from "../../utils";

import styles from "./SupportButton.module.scss";

interface Props {
  className?: string;
  variant?: "inline" | "floating";
  testId?: string;
}

const SupportButton = ({
  className,
  variant = "floating",
  testId = "support-button",
}: Props) => {
  const { floating } = styles;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClick = (action: () => void) => () => {
    setIsOpen(false);
    action();
  };

  const options = [
    {
      label: "Email",
      icon: <Icon name="mail" />,
      onClick: onClick(() => {
        window.location.href = getMailLink();
      }),
    },
    {
      label: "WhatsApp",
      icon: <Icon name="whatsapp" />,
      onClick: onClick(() => {
        window.open(getWhatsappLink(), "_blank", "noreferrer");
      }),
    },
  ];

  const menuItems = options.map(({ label, icon, onClick: onItemClick }) => ({
    label,
    leadingIcon: icon,
    onClick: onItemClick,
  }));

  const dropdownItems = options.map(
    ({ label, icon, onClick: onItemClick }) => ({
      label,
      startContent: icon,
      onClick: onItemClick,
    }),
  );

  if (variant === "inline")
    return (
      <Button
        variant="secondary"
        size="small"
        text="Contactar soporte"
        leadingIcon={<Icon name="support" />}
        className={className}
        menu={menuItems}
        testId={testId}
      />
    );

  return (
    <motion.div
      key="supportOptions"
      initial={{ y: "100%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.5 }}
      className={`${floating} ${className ?? ""}`}
      data-testid={testId}
    >
      <Dropdown
        trigger={
          <IconButton
            variant="outline"
            size="large"
            icon={<Icon name="support" />}
            aria-label="Contactar soporte"
          />
        }
        items={dropdownItems}
        open={isOpen}
        onOpenChange={setIsOpen}
        align="end"
        side="top"
        width="12.5rem"
        testId={testId}
      />
    </motion.div>
  );
};

export default SupportButton;
